<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'SiteForm',
}
</script>

<style scoped></style>
